import { Injectable } from '@angular/core'

import { CustomSensor } from '@ti/contracts'
import { BaseCustomSensorsProvider } from '@ti/shared/fleet/contracts'

@Injectable()
export class TspCustomSensorsAlertsProvider extends BaseCustomSensorsProvider<CustomSensor> {
  protected async getCustomSensors() {
    return []
  }
}
